import { memo } from 'react';

export const TemplateCenter = memo(() => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>模板中心</title>
    <defs>
      <filter
        x="-30.0%"
        y="-29.6%"
        width="160.0%"
        height="159.3%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feGaussianBlur stdDeviation="2" in="SourceGraphic"></feGaussianBlur>
      </filter>
      <filter
        x="-37.5%"
        y="-98.8%"
        width="175.0%"
        height="297.6%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur
          stdDeviation="0.909090909"
          in="SourceGraphic"
        ></feGaussianBlur>
      </filter>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="178.80188%"
        gradientTransform="translate(0.096921,0.000000),scale(0.512996,1.000000),rotate(39.031402),translate(-0.096921,-0.000000)"
        id="radialGradient-3"
      >
        <stop stopColor="#70A9FF" offset="0%"></stop>
        <stop stopColor="#526DFF" offset="100%"></stop>
      </radialGradient>
      <radialGradient
        cx="10.4584409%"
        cy="1.21110669%"
        fx="10.4584409%"
        fy="1.21110669%"
        r="175.331329%"
        gradientTransform="translate(0.104584,0.012111),scale(0.512996,1.000000),rotate(39.031402),translate(-0.104584,-0.012111)"
        id="radialGradient-4"
      >
        <stop stopColor="#ABCCFF" offset="0%"></stop>
        <stop stopColor="#91A3FF" offset="100%"></stop>
      </radialGradient>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="178.80188%"
        gradientTransform="translate(0.096921,0.000000),scale(0.512996,1.000000),rotate(39.031402),translate(-0.096921,-0.000000)"
        id="radialGradient-5"
      >
        <stop stopColor="#7BB0FF" offset="0%"></stop>
        <stop stopColor="#617AFF" offset="100%"></stop>
      </radialGradient>
    </defs>
    <g id="UI稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="首页-交互细节" transform="translate(-839.000000, -297.000000)">
        <g
          id="nav/选中状态备份-2"
          transform="translate(827.000000, 287.000000)"
        >
          <g id="nav/工作台-s" transform="translate(12.000000, 10.000000)">
            <g id="nav/模板中心" transform="translate(0.000000, 0.760000)">
              <ellipse
                id="椭圆形"
                fill="#5363FF"
                opacity="0.158657982"
                filter="url(#filter-1)"
                cx="10"
                cy="10.12"
                rx="10"
                ry="10.12"
              ></ellipse>
              <ellipse
                id="椭圆形"
                fill="#FFFFFF"
                opacity="0.437244234"
                filter="url(#filter-2)"
                cx="10"
                cy="17.26"
                rx="3.63636364"
                ry="1.38"
              ></ellipse>
              <path
                d="M10.466815,9.10979025 L18.574649,13.025274 C18.994465,13.2280141 19.1257929,13.6599941 18.8679781,13.9901284 C18.7946109,14.0840758 18.6941174,14.1631017 18.574649,14.2207961 L10.466815,18.1362799 C10.1804493,18.2745734 9.81955073,18.2745734 9.53318502,18.1362799 L1.42535102,14.2207961 C1.00553504,14.0180561 0.874207137,13.5860761 1.13202193,13.2559418 C1.20538915,13.1619943 1.30588258,13.0829684 1.42535102,13.025274 L9.53318502,9.10979025 C9.81955073,8.9714968 10.1804493,8.9714968 10.466815,9.10979025 Z"
                id="矩形备份-14"
                fill="url(#radialGradient-3)"
              ></path>
              <path
                d="M10.466815,4.72675517 L18.574649,8.64223895 C18.994465,8.84497899 19.1257929,9.27695901 18.8679781,9.60709333 C18.7946109,9.70104075 18.6941174,9.78006664 18.574649,9.83776105 L10.466815,13.7532448 C10.1804493,13.8915383 9.81955073,13.8915383 9.53318502,13.7532448 L1.42535102,9.83776105 C1.00553504,9.63502101 0.874207137,9.20304099 1.13202193,8.87290667 C1.20538915,8.77895925 1.30588258,8.69993336 1.42535102,8.64223895 L9.53318502,4.72675517 C9.81955073,4.58846172 10.1804493,4.58846172 10.466815,4.72675517 Z"
                id="矩形备份-13"
                fill="url(#radialGradient-4)"
              ></path>
              <path
                d="M10.466815,0.343720085 L18.574649,4.25920387 C18.994465,4.46194391 19.1257929,4.89392393 18.8679781,5.22405825 C18.7946109,5.31800567 18.6941174,5.39703156 18.574649,5.45472597 L10.466815,9.37020975 C10.1804493,9.5085032 9.81955073,9.5085032 9.53318502,9.37020975 L1.42535102,5.45472597 C1.00553504,5.25198593 0.874207137,4.8200059 1.13202193,4.48987159 C1.20538915,4.39592417 1.30588258,4.31689828 1.42535102,4.25920387 L9.53318502,0.343720085 C9.81955073,0.205426638 10.1804493,0.205426638 10.466815,0.343720085 Z"
                id="矩形"
                fill="url(#radialGradient-5)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
));
